import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TermsService } from '@client/app/modules/terms/terms.service';
import { privacy_terms } from '@monsido/core/constants/general.constant';

@Component({
    selector: 'privacy-dialog-modern',
    templateUrl: './privacy-dialog-modern.component.html',
    standalone: false,
})
export class PrivacyDialogModernComponent implements OnInit {
    terms = '';
    accept = false;
    saving = false;
    version = '';

    constructor (
        private readonly dialogRef: DynamicDialogRef,
        private readonly dialogConfig: DynamicDialogConfig,
        private readonly sanitizer: DomSanitizer,
        private readonly monEventService: MonEventService,
        private readonly termsService: TermsService,
    ) {}

    ngOnInit (): void {
        this.version = this.dialogConfig.data?.version ?? '';
        this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-show' });
        this.terms = this.sanitizer.sanitize(SecurityContext.HTML, privacy_terms) ?? '';
    }

    submit (): void {
        if (!this.accept || this.saving) {
            return;
        }

        this.saving = true;
        this.termsService.accept(this.version)
            .then(() => {
                this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-accepted' });
                this.dialogRef.close();
            })
            .catch(() => {
                // The global error interceptor shows the error; keep the dialog open so the user can retry
            })
            .finally(() => {
                this.saving = false;
            });
    }
}
